import { AxiosResponse } from 'axios';

import { IBooking } from '../../shared/ts/booking';
import { IUser } from '../../shared/ts/user';
import {
  BookingWithDocuments,
  BookingWithDocumentsStatus,
  BookingDocument,
} from '../../types/documents';
import httpRequest from '../httpRequest';

interface GetBookingsWithDocumentsParams {
  userType: IUser['type'];
  status?: Array<BookingWithDocumentsStatus>;
}

interface GetBookingDocumentParams {
  bookingId: BookingWithDocuments['id'];
  bookingAttachmentId: BookingDocument['id'];
}

interface GetBookingAttachmentDocumentTypeParams {
  bookingId?: BookingWithDocuments['id'];
  type?: BookingDocument['type'];
  attachmentId?: string;
}

const bookingDocumentsAPI = {
  getBookingById: async (id: string): Promise<IBooking> => {
    const { data } = (await httpRequest({
      baseURL: process.env.REACT_APP_API_BOOKING_URL,
      url: `/bookings/${id}`,
      method: 'GET',
    })) as AxiosResponse;

    return data;
  },

  getBookingsWithDocuments: async ({
    userType,
    status,
  }: GetBookingsWithDocumentsParams): Promise<Array<BookingWithDocuments>> => {
    const { data } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/bookings?f=${encodeURIComponent(
        JSON.stringify({
          user_type: userType,
          status: status?.length === 1 ? status[0] : undefined,
        }),
      )}`,
      method: 'GET',
    })) as AxiosResponse;

    return data.data;
  },
  getBookingDocumentURL: async ({
    bookingId,
    bookingAttachmentId,
  }: GetBookingDocumentParams): Promise<string> => {
    const { data } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/bookings/${bookingId}/booking-attachments/${bookingAttachmentId}/url`,
      method: 'POST',
    })) as AxiosResponse;

    return data.presigned_url;
  },

  getBookingAttachmentByType: async ({
    bookingId,
    type,
  }: GetBookingAttachmentDocumentTypeParams): Promise<string[]> => {
    const { data } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/bookings/${bookingId}/booking-attachments/${type}`,
      method: 'GET',
    })) as AxiosResponse;

    return data;
  },

  deleteBookingAttachment: async ({ id }: { id: string }): Promise<string> => {
    const { data } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/booking-attachments/${id}`,
      method: 'DELETE',
    })) as AxiosResponse;

    return data;
  },

  getBookingReceiptUrl: async (
    bookingId: string,
  ): Promise<{ presigned_url: string }> => {
    const { data } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/bookings/${bookingId}/booking-receipt-url`,
      method: 'GET',
    })) as AxiosResponse;

    return data;
  },
};

export default bookingDocumentsAPI;
